function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#445058",
  fillRule: "evenodd",
  d: "M 3.54 17.03 C 1.82 17.03 0.8 16.7 0 16.19 L 0.53 14.77 C 1.11 15.13 1.97 15.48 3.19 15.48 C 4.94 15.48 6.04 14.35 6.04 12.63 C 6.04 11.28 5.29 10.46 3.39 9.71 C 0.84 8.69 0.16 7.12 0.16 5.64 C 0.16 3.34 1.8 1.37 4.45 1.37 C 5.84 1.37 6.91 1.72 7.57 2.19 L 7.08 3.47 C 6.55 3.14 5.69 2.76 4.67 2.76 C 3.06 2.76 2.15 3.82 2.15 5.44 C 2.15 7.01 3.3 7.67 4.69 8.22 C 7.7 9.4 8.14 11.17 8.14 12.52 C 8.14 15.17 6.22 17.03 3.54 17.03 L 3.54 17.03 Z M 3.54 17.03"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#445058",
  fillRule: "evenodd",
  d: "M 23.86 16.78 L 23.86 8.22 C 23.86 7.03 23.3 5.95 21.58 5.95 C 20.58 5.95 19.82 6.28 19.14 7.01 L 19.14 16.78 L 17.17 16.78 L 17.17 8.14 C 17.17 6.81 16.3 5.93 14.57 5.93 C 13.6 5.93 13.03 6.06 12.44 6.32 L 12.44 16.78 L 10.48 16.78 L 10.48 5.51 C 11.56 4.98 12.71 4.67 14.61 4.67 C 16.45 4.67 17.56 5.22 18.27 6.1 C 19.08 5.24 20.3 4.67 21.96 4.67 C 24.81 4.67 25.83 6.52 25.83 8.18 L 25.83 16.78 L 23.86 16.78 L 23.86 16.78 Z M 23.86 16.78"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#445058",
  fillRule: "evenodd",
  d: "M 32.41 17.03 C 29.31 17.03 27.9 15.68 27.9 13.51 C 27.9 10.35 30.85 9.42 34.58 9.04 L 34.58 8.31 C 34.58 6.48 33.46 5.95 31.93 5.95 C 30.78 5.95 29.71 6.37 29.04 6.7 L 28.57 5.55 C 29.26 5.17 30.57 4.66 32.21 4.66 C 34.42 4.66 36.36 5.61 36.36 8.54 L 36.36 16.19 C 35.47 16.7 34.06 17.03 32.41 17.03 L 32.41 17.03 Z M 34.58 10.04 C 31.53 10.42 29.76 11.06 29.76 13.47 C 29.76 15.2 30.83 15.9 32.6 15.9 C 33.36 15.9 34.09 15.77 34.58 15.51 L 34.58 10.04 L 34.58 10.04 Z M 34.58 10.04"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#445058",
  fillRule: "evenodd",
  d: "M 44.28 6.17 C 43.3 5.88 42.16 5.97 41.57 6.39 L 41.57 16.78 L 39.6 16.78 L 39.6 5.53 C 40.78 4.93 41.91 4.62 44.74 4.69 L 44.28 6.17 L 44.28 6.17 Z M 44.28 6.17"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#445058",
  fillRule: "evenodd",
  d: "M 50.54 16.92 C 48.37 16.92 47.58 15.37 47.58 13.91 L 47.58 6.06 L 46.2 6.06 L 46.2 4.88 L 47.58 4.88 L 47.58 2.14 L 49.54 1.55 L 49.54 4.88 L 51.61 4.88 L 51.61 6.06 L 49.54 6.06 L 49.54 13.87 C 49.54 14.82 49.96 15.6 51.04 15.6 C 51.24 15.6 51.41 15.55 51.61 15.51 L 51.61 16.75 C 51.31 16.81 51.03 16.92 50.54 16.92 L 50.54 16.92 Z M 50.54 16.92"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#445058",
  fillRule: "evenodd",
  d: "M 97.19 16.92 C 95.02 16.92 94.22 15.37 94.22 13.91 L 94.22 6.06 L 92.84 6.06 L 92.84 4.88 L 94.22 4.88 L 94.22 2.14 L 96.19 1.55 L 96.19 4.88 L 98.25 4.88 L 98.25 6.06 L 96.19 6.06 L 96.19 13.87 C 96.19 14.82 96.6 15.6 97.69 15.6 C 97.89 15.6 98.06 15.55 98.26 15.51 L 98.26 16.75 C 98.05 16.81 97.67 16.92 97.19 16.92 L 97.19 16.92 Z M 97.19 16.92"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#445058",
  fillRule: "evenodd",
  d: "M 101.75 2.58 C 101.11 2.58 100.6 2.1 100.6 1.52 C 100.6 0.93 101.11 0.44 101.75 0.44 C 102.37 0.44 102.88 0.92 102.88 1.52 C 102.88 2.1 102.37 2.58 101.75 2.58 L 101.75 2.58 Z M 100.81 16.78 L 100.81 4.87 L 102.68 4.87 L 102.68 16.78 L 100.81 16.78 L 100.81 16.78 Z M 100.81 16.78"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#445058",
  fillRule: "evenodd",
  d: "M 112.72 16.78 L 112.72 8.25 C 112.72 7.14 112.22 5.92 110.18 5.92 C 109.08 5.92 108.58 6.08 107.89 6.34 L 107.89 16.78 L 106.02 16.78 L 106.02 5.5 C 107.01 5 108.43 4.66 110.34 4.66 C 113.66 4.66 114.59 6.5 114.59 8.2 L 114.59 16.78 L 112.72 16.78 L 112.72 16.78 Z M 112.72 16.78"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#445058",
  fillRule: "evenodd",
  d: "M 67.22 16.88 C 67.2 16.68 67.01 3.7 67.01 3.7 L 66.96 3.7 C 66.96 3.7 62.69 16.59 62.6 16.88 L 61.25 16.88 C 61.18 16.59 56.93 3.7 56.93 3.7 L 56.88 3.7 C 56.88 3.7 56.67 16.59 56.65 16.88 L 54.72 16.88 L 55.47 1.63 L 57.79 1.63 L 61.56 12.61 C 61.85 13.63 61.96 14.32 61.96 14.32 L 62 14.32 C 62 14.32 62.11 13.63 62.4 12.63 L 66.26 1.63 L 68.58 1.63 L 69.32 16.88 L 67.22 16.88 L 67.22 16.88 Z M 67.22 16.88"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#445058",
  fillRule: "evenodd",
  d: "M 75.91 4.66 C 73.53 4.66 71.36 6.72 71.29 10.81 C 71.19 16.29 75.97 18.4 79.61 15.56 C 79.56 15.17 79.39 14.65 79.28 14.51 C 78.13 15.41 73.37 16.81 73.05 11.59 L 80.44 11.57 C 80.68 6.94 78.81 4.66 75.91 4.66 L 75.91 4.66 Z M 73.05 10.38 C 72.99 7.32 74.47 5.9 76.05 5.92 C 77.74 5.93 79.05 7.32 78.87 10.4 L 73.05 10.38 L 73.05 10.38 Z M 73.05 10.38"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#445058",
  fillRule: "evenodd",
  d: "M 122.15 4.66 C 118.56 4.66 116.57 7.27 116.57 11.06 C 116.57 14.69 118.36 16.94 121.21 16.94 C 122.25 16.94 123.15 16.72 123.84 16.41 L 123.84 17.69 C 123.84 19.48 122.02 20.5 120.67 20.48 C 119.64 20.47 118.68 20.18 117.79 19.47 C 117.62 19.67 117.38 20.01 117.15 20.37 C 118.65 21.55 120.29 21.74 121.03 21.74 C 122.95 21.74 126 20.66 126 17.05 L 126 5.73 C 124.92 5.09 123.81 4.66 122.15 4.66 L 122.15 4.66 Z M 123.83 15.48 C 123.12 15.77 122.76 15.79 122 15.79 C 119.72 15.79 118.52 14.07 118.52 10.99 C 118.52 7.85 119.88 5.84 122.29 5.84 C 122.98 5.84 123.56 5.96 123.85 6.18 L 123.83 15.48 L 123.83 15.48 Z M 123.83 15.48"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#445058",
  fillRule: "evenodd",
  d: "M 87.06 4.66 C 84.68 4.66 82.51 6.72 82.43 10.81 C 82.34 16.29 87.12 18.4 90.75 15.56 C 90.71 15.17 90.54 14.65 90.43 14.51 C 89.27 15.41 84.52 16.81 84.19 11.59 L 91.59 11.57 C 91.82 6.94 89.96 4.66 87.06 4.66 L 87.06 4.66 Z M 84.19 10.38 C 84.14 7.32 85.62 5.9 87.19 5.92 C 88.88 5.93 90.2 7.32 90.02 10.4 L 84.19 10.38 L 84.19 10.38 Z M 84.19 10.38"
});

var SvgSmClaim = function SvgSmClaim(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 22,
    width: 126,
    viewBox: "0 0 126 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmClaim, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sm-claim.27c11bb1.svg";
export { ForwardRef as ReactComponent };